export const BudgetStepSection = {
  Budget: 'budget',
  BidStrategy: 'bid-strategy',
};

export const AllBudgetStepSections = [
  BudgetStepSection.Budget,
  BudgetStepSection.BidStrategy,
];
